// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import { createValidator } from '#runtime/validation/index.ts';
import * as compiled from './user.compiled.ts';

export const validateDeleteUserRequestPayload = /* @__PURE__ */ createValidator(
  compiled.validateDeleteUserRequestPayload,
  {},
);
export const validateGetProjectsWhereAdminRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateGetProjectsWhereAdminRequestPayload,
    {},
  );
export const validateGetUserDataRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateGetUserDataRequestPayload,
    {},
  );
export const validateGetUserProjectsRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateGetUserProjectsRequestPayload,
    {},
  );
export const validateListUsersRequestPayload = /* @__PURE__ */ createValidator(
  compiled.validateListUsersRequestPayload,
  {
    page: { minimum: 1 },
    page_size: { minimum: 1, maximum: 100 },
    project_id: { minLength: 1 },
    query_text: { maxLength: 200 },
  },
);
export const validateSaveUserRequestPayload = /* @__PURE__ */ createValidator(
  compiled.validateSaveUserRequestPayload,
  {},
);
export const validateSetUserDisplayNameRequestPayload =
  /* @__PURE__ */ createValidator(
    compiled.validateSetUserDisplayNameRequestPayload,
    { displayName: { minLength: 2, maxLength: 100 } },
  );
